import authService from './authService';
import { SalesGoal, SalesGoalUpsertPayload } from '../types/salesGoal';
import { ApiResponse } from '../types/common';

/**
 * Sales Goal Service (Meta de Venda)
 *
 * Gerencia a meta de vendas mensal consolidada da Viver Organizer.
 * Endpoint base: /api/sales-goals
 */
class SalesGoalService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /**
   * Busca as metas de venda de um ano.
   * GET /api/sales-goals?year={year}
   */
  async getByYear(year: number): Promise<SalesGoal[]> {
    const params = new URLSearchParams({ year: year.toString() });
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/sales-goals?${params}`);
    if (!response.ok) throw new Error('Falha ao buscar metas de venda');
    const json = await response.json();
    return (json.data ?? json) as SalesGoal[];
  }

  /**
   * Cria ou atualiza uma meta de venda (upsert).
   * PUT /api/sales-goals
   */
  async upsert(payload: SalesGoalUpsertPayload): Promise<SalesGoal> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.put('/sales-goals', payload);
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.message || 'Falha ao salvar meta de venda');
    }
    const json: ApiResponse<SalesGoal> = await response.json();
    return json.data!;
  }

  /**
   * Remove uma meta de venda.
   * DELETE /api/sales-goals?reference_date={date}
   */
  async delete(referenceDate: string): Promise<void> {
    const params = new URLSearchParams({ reference_date: referenceDate });
    const apiClient = await this.getApiClient();
    const response = await apiClient.delete(`/sales-goals?${params}`);
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(body?.message || 'Falha ao excluir meta de venda');
    }
  }
}

export const salesGoalService = new SalesGoalService();
export default salesGoalService;
